import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Image, Space, Table, Tag } from "antd";
import { getMediaUrl } from 'config/env';
import { Link, useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';

const isMissingImage = (value) => {
  if (value === null || value === undefined) return true;

  const normalizedValue = String(value).trim().toLowerCase();
  return normalizedValue === "" || normalizedValue === "null" || normalizedValue === "undefined";
};

function Locations() {
  const navigate = useNavigate();

  const [allLocations, setAllLocations] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const getAllLocations = () => {
    Axios.get("/location")
      .then((res) => {
        setAllLocations(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getAllLocations()
  }, []);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const deleteDoc = (location) => {
    if (window.confirm(`آیا شعبه  "${location.name_fa}" حذف گردد؟`)) {
      deleteDocHandler(location);
    }
  };

  const deleteDocHandler = (location) => {
    Axios.delete(`location/${location.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
        }
        getAllLocations()
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };
  const goToAddPage = () => {
    navigate("/locations/add")
  }

  const goToSortingPage = () => {
    navigate("/locations/sorting")
  }

  const columns = [
    {
      title: "تصویر",
      dataIndex: "image",
      key: "image",
      render: (_, record) => {
        const imageWasCleared =
          Object.prototype.hasOwnProperty.call(record, "image") &&
          isMissingImage(record.image);
        const previewUrl = imageWasCleared
          ? ""
          : [record.image_thumbnail, record.image_optimized, record.image]
            .find((value) => !isMissingImage(value)) || "";

        return previewUrl ? (
          <Image
            width={48}
            height={48}
            preview={false}
            src={getMediaUrl(previewUrl)}
            alt={record.name_fa}
            style={{ objectFit: 'cover', borderRadius: '4px' }}
          />
        ) : (
          <span className='w-full d-flex justify-content-center align-items-center'>-</span>
        );
      },
    },
    {
      title: "نام شعبه",
      dataIndex: "name_fa",
      key: "name_fa",
      sorter: (a, b) =>
        a.name_fa > b.name_fa ? 1 : b.name_fa > a.name_fa ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "name_fa" ? sortedInfo.order : null,
      ellipsis: true,
      render: (text, record) => (
        <Space>
          <span>{text}</span>
          {record['is_Central_office'] && (
            <Tag color="gold">مرکزی</Tag>
          )}
        </Space>
      ),
    },
    // {
    //   title: "نام انگلیسی",
    //   dataIndex: "name_en",
    //   key: "name_en",
    //   sorter: (a, b) =>
    //     a.name_en > b.name_en ? 1 : b.name_en > a.name_en ? -1 : 0,
    //   sortOrder: sortedInfo.columnKey === "name_en" ? sortedInfo.order : null,
    //   ellipsis: true,
    // },
    // {
    //   title: "آدرس فارسی",
    //   dataIndex: "address_fa",
    //   key: "address_fa",
    //   ellipsis: true,
    // },
    {
      title: "تلفن ثابت",
      dataIndex: "phone1",
      key: "phone1",
      ellipsis: true,
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, location) => (
        <Space size="small">
          <Link
            to={`/locations/edit/${location.id}`}
            className="btn btn-primary btn-sm"
          >ویرایش</Link>
          <button
            onClick={() => deleteDoc(location)}
            className="btn btn-danger btn-sm"
          >حذف</button>
        </Space>
      ),
    },
  ];
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button onClick={goToAddPage}>اضافه کردن</Button>
          <Button 
            onClick={goToSortingPage}
          >
            مرتب‌سازی و ترتیب‌بندی
          </Button>
        </Space>
        <div>
          {allLocations ?
            allLocations[0] ?
              <Table
                pagination={false}
                columns={columns}
                dataSource={allLocations}
                rowKey="id"
                onChange={handleChange}
              />
              : <h2>محتوایی نیست</h2> : <Loading />}
        </div>
      </div>
    </div>
  );
}
export default Locations

